import { toast } from "react-toastify";
import { Toast } from "../../config/Toast";
import Modal from "../../components/Modal";
import MasterBpjsService from "../../services/MasterBonus";
import AlertIcon from "../../components/icons/AlertIcon.jsx";
import "react-toastify/dist/ReactToastify.css";

const MasterBonusDelete = (props) => {
  const data = props.data;

  const notifySuccess = (message) => toast.success(message, Toast);
  const notifyFailed = (message) => toast.error(message, Toast);

  const submitHandler = () => {
    MasterBpjsService.delete(data.data.id, { deleted_by: data.user.id })
      .then(() => {
        props.setUpdate(true);
        notifySuccess(`Nominal Bonus berhasil dihapus`);
      })
      .catch((err) => {
        console.log(err);
        notifyFailed(err.response.data.message);
      });

    props.closeClick();
  };

  return (
    <Modal
      activeModal={props.activeModal}
      modalHeader="false"
      closeClick={props.closeClick}
      submitHandler={submitHandler}
      type="Ya, Delete"
      ButtonConfirmOnly={true}
      widthButtonConfirmOnly="auto"
    >
      <div className="d-flex flex-column w-100 justify-content-center align-items-center w-100">
        <div className="d-flex flex-column w-100 justify-content-center align-items-center">
          <AlertIcon />
        </div>

        <div className="d-flex flex-column w-100 justify-content-center align-items-center mt-5">
          <h5 className="fw-bold lh-1 fs-4">Hapus Aturan Bonus</h5>
          <p className="lh-1 fs-6 w-70">Apakah kamu yakin ingin menghapus aturan bonus ini?</p>
        </div>
      </div>
    </Modal>
  );
};

export default MasterBonusDelete;
